import { ReactNode } from 'react';
import NavigationButton, { NavigationButtonProps } from './NavigationButton';

export interface TubeNavigationProps
  extends Omit<NavigationButtonProps, 'icon'> {
  children?: ReactNode;
}

export const TubeNavigation = ({
  label,
  id,
  onClick,
  active = false,
  children,
}: TubeNavigationProps) => {
  return (
    <NavigationButton
      icon='material-symbols:play-circle-outline'
      label={label}
      id={id}
      onClick={onClick}
      active={active}
    >
      {children}
    </NavigationButton>
  );
};

export default TubeNavigation;
